import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listOwners } from '../Api'

export default generateApiAction({
  baseType: Types.OWNERS.LIST,
  api: listOwners,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/owners/ListAction.js